export class DriverLicenseVerification {
  private readonly shouldCheckDriverLicense: boolean

  private readonly mandatoryDLCheck: boolean

  private readonly isDriverDocValid: boolean | null

  private readonly hasDriverDoc: boolean

  constructor(shouldCheckDriverLicense: boolean, mandatoryDLCheck: boolean, isDriverDocValid: boolean | null, hasDriverDoc: boolean) {
    this.shouldCheckDriverLicense = shouldCheckDriverLicense
    this.mandatoryDLCheck = mandatoryDLCheck
    this.isDriverDocValid = isDriverDocValid
    this.hasDriverDoc = hasDriverDoc
  }

  private isMandatoryCheckActive(): boolean {
    return this.shouldCheckDriverLicense && this.mandatoryDLCheck && this.hasDriverDoc
  }

  public canNotSetPositiveResolution(): boolean {
    if (!this.isMandatoryCheckActive()) return false
    return this.isDriverDocValid === null || this.isDriverDocValid === false
  }

  public isUncheckedValidationMessageVisible(resolutionIsPositive: boolean): boolean {
    return this.isMandatoryCheckActive() && this.isDriverDocValid === null && resolutionIsPositive
  }

  public isInvalidValidationMessageVisible(resolutionIsPositive: boolean): boolean {
    return this.isMandatoryCheckActive() && this.isDriverDocValid === false && resolutionIsPositive
  }
}
